
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/banquet-halls-in-shimla",
      function () {
        return require("private-next-pages/banquet-halls-in-shimla.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/banquet-halls-in-shimla"])
      });
    }
  